if (!window.Eurus.loadedScript.has('collection-list-product-wishlist-button.js')) {
  window.Eurus.loadedScript.add('collection-list-product-wishlist-button.js');

  function getSwymApi(callback) {
    if (window._swat) {
      callback(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push((swymApi) => callback(swymApi || window._swat));
  }

  function getWishlistItemFromButton(button) {
    return {
      epi: Number(button.dataset.variantId),
      empi: Number(button.dataset.productId),
      du: button.dataset.productUrl
    };
  }

  function isMatchingWishlistItem(wishlistItem, currentItem) {
    if (!wishlistItem || !currentItem) return false;

    const wishlistVariantId = Number(wishlistItem.epi || wishlistItem.variant_id || wishlistItem.variantId);
    const wishlistProductId = Number(wishlistItem.empi || wishlistItem.product_id || wishlistItem.productId);

    if (wishlistVariantId && currentItem.epi) {
      return wishlistVariantId === currentItem.epi;
    }

    return wishlistProductId && currentItem.empi && wishlistProductId === currentItem.empi;
  }

  function setMatchingWishlistButtonsState(currentItem, isAdded) {
    document.querySelectorAll('.collection-list-product-wishlist-button').forEach((button) => {
      const buttonItem = getWishlistItemFromButton(button);
      if (!isMatchingWishlistItem(buttonItem, currentItem)) return;

      button.classList.toggle('is-added', isAdded);
      button.classList.toggle('swym-added', isAdded);
      button.setAttribute('aria-pressed', isAdded.toString());

      if (button._x_dataStack?.[0]) {
        button._x_dataStack[0].isAddedToCollectionWishlist = isAdded;
      }
    });
  }

  function fetchWishlistItems(swymApi, callback) {
    if (!swymApi) {
      callback([]);
      return;
    }

    if (typeof swymApi.fetch === 'function') {
      swymApi.fetch((wishlistItems) => callback(Array.isArray(wishlistItems) ? wishlistItems : []));
      return;
    }

    if (typeof swymApi.fetchWrtEventTypeET === 'function') {
      swymApi.fetchWrtEventTypeET((wishlistItems) => callback(Array.isArray(wishlistItems) ? wishlistItems : []), 4);
      return;
    }

    callback([]);
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCollectionListProductWishlistButton', () => ({
      canShowCollectionWishlistButton: false,
      isAddedToCollectionWishlist: false,
      isUpdatingCollectionWishlist: false,
      init() {
        if (window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            () => this.updateCollectionWishlistConsent()
          );
        } else {
          this.updateCollectionWishlistConsent();
        }

        document.addEventListener('visitorConsentCollected', () => this.updateCollectionWishlistConsent());
        this.updateCollectionWishlistState();
      },
      toggleCollectionProductWishlist() {
        if (this.isUpdatingCollectionWishlist) return;

        if (this.isAddedToCollectionWishlist) {
          this.removeCollectionProductFromWishlist();
          return;
        }

        this.addCollectionProductToWishlist();
      },
      addCollectionProductToWishlist() {
        this.isUpdatingCollectionWishlist = true;

        getSwymApi((swymApi) => {
          const swymAddToWishlist = swymApi && (swymApi.addToWishList || swymApi.addToWishlist);
          const wishlistItem = getWishlistItemFromButton(this.$el);

          if (typeof swymAddToWishlist !== 'function') {
            this.isUpdatingCollectionWishlist = false;
            return;
          }

          swymAddToWishlist.call(swymApi, wishlistItem, () => {
            this.isAddedToCollectionWishlist = true;
            this.isUpdatingCollectionWishlist = false;
            setMatchingWishlistButtonsState(wishlistItem, true);
          });
        });
      },
      removeCollectionProductFromWishlist() {
        this.isUpdatingCollectionWishlist = true;

        getSwymApi((swymApi) => {
          const swymRemoveFromWishlist = swymApi && (swymApi.removeFromWishList || swymApi.removeFromWishlist);
          const wishlistItem = getWishlistItemFromButton(this.$el);

          if (typeof swymRemoveFromWishlist !== 'function') {
            this.isUpdatingCollectionWishlist = false;
            return;
          }

          swymRemoveFromWishlist.call(swymApi, wishlistItem, () => {
            this.isAddedToCollectionWishlist = false;
            this.isUpdatingCollectionWishlist = false;
            setMatchingWishlistButtonsState(wishlistItem, false);
          });
        });
      },
      updateCollectionWishlistState() {
        getSwymApi((swymApi) => {
          const wishlistItem = getWishlistItemFromButton(this.$el);

          fetchWishlistItems(swymApi, (wishlistItems) => {
            this.isAddedToCollectionWishlist = wishlistItems.some((item) => isMatchingWishlistItem(item, wishlistItem));
          });
        });
      },
      updateCollectionWishlistConsent() {
        const customerPrivacy = window.Shopify?.customerPrivacy;

        if (!customerPrivacy) {
          this.canShowCollectionWishlistButton = false;
          return;
        }

        const currentConsent = customerPrivacy.currentVisitorConsent?.();
        this.canShowCollectionWishlistButton = customerPrivacy.userCanBeTracked?.() || currentConsent?.preferences === 'yes';
      }
    }));
  });
}
